import type { FaireProductEntity } from "../../entity_types/product";

export const p_3tuv5fmh: FaireProductEntity = {
  token: "p_3tuv5fmh",
  type: "product",
  name: "My Dog And I Talk Shit About You Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d39f7f65aaa61aa1a93d2bfa939d7466b53347f7a0781e06b5d76de756e26b5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/900e7ecd6dc12fc0aec21ce72a7236fa57a31ebb22c258619f363e91846ccf10.jpeg",
    "https://cdn.faire.com/fastly/e5f5f750a168543908de3b6d2b7fef5d4485730c7444de5d4f6af191b303f2ef.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ca6a74fe1f48a18495763bbac97dc9994db541cabdde51aaa41ac69821da3db6.jpeg"
  ],
  priceDollars: 6.75,
  description: "Anyone with a dog knows that they keep secrets better than any human. Nice to have some shit you don’t have to bag up, too. \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:57.215Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
